module.exports = __webpack_public_path__ + "static/media/,,.e6c46f7d.svg";